import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';
import type { UploadResponse } from '@/types/api';

export function useUploadMonthlyPlan() {
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const res = await apiClient.post<UploadResponse>(
        '/monthly-plan/upload',
        formData
      );
      return res.data;
    },
  });
}
